import {
  IMessageBarStyleProps,
  IMessageBarStyles,
  MessageBarType
} from '@fluentui/react/lib/MessageBar';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';
import { ContrastColors, CoreColors, DarkColors } from '../teams-colors';
import { FontSizes } from '../teams-type';

export function getMessageBarStyles(themeName: string, _theme: ITheme) {
  return (props: IMessageBarStyleProps): Partial<IMessageBarStyles> => {
    const { theme, messageBarType } = props;

    const margin = {
      marginTop: '12px',
      marginBottom: '12px'
    };

    let ERROR_COLOR = CoreColors.appRed;
    let ERROR_BACKGROUND_COLOR = CoreColors.appRed10;
    let ERROR_BOTTOM_BORDER_COLOR = CoreColors.appRed08;

    let INFO_COLOR = theme.palette.neutralDark;
    let INFO_BACKGROUND_COLOR = theme.palette.neutralTertiaryAlt;
    let INFO_BOTTOM_BORDER_COLOR = theme.palette.neutralTertiary;

    if (themeName === 'dark') {
      ERROR_COLOR = DarkColors.appRed;
      ERROR_BACKGROUND_COLOR = DarkColors.appRed10;
      ERROR_BOTTOM_BORDER_COLOR = DarkColors.appRed08;
    }
    if (themeName === 'contrast') {
      ERROR_COLOR = ContrastColors.appWhite;
      ERROR_BACKGROUND_COLOR = ContrastColors.appRed10;
      ERROR_BOTTOM_BORDER_COLOR = ContrastColors.appRed08;

      INFO_COLOR = ContrastColors.appWhite;
      INFO_BACKGROUND_COLOR = ContrastColors.appRed10;
      INFO_BOTTOM_BORDER_COLOR = ContrastColors.appRed08;
    }

    const styles = {
      actions: {},
      iconContainer: [
        {
          ...margin
        }
      ],
      icon: {
        display: 'none'
      },
      dismissal: [
        {
          width: '26px',
          height: 'auto',
          ...margin,
          selectors: {
            '.ms-Button-icon': {
              fontSize: FontSizes.size10,
              fontWeight: 'bold'
            }
          }
        },
        messageBarType === MessageBarType.error && {
          color: ERROR_COLOR,
          selectors: {
            '.ms-Button-icon': {
              color: ERROR_COLOR
            }
          }
        },
        messageBarType === MessageBarType.info && {
          color: INFO_COLOR,
          selectors: {
            '.ms-Button-icon': {
              color: INFO_COLOR
            }
          }
        }
      ],
      text: [
        {
          fontSize: FontSizes.size14,
          fontWeight: FontWeights.semibold,
          justifyContent: 'center',
          flexGrow: 1,
          ...margin
        }
      ],
      root: [
        {
          selectors: {
            '.ms-Link': {
              fontWeight: 'inherit',
              fontSize: 'inherit',
              textDecoration: 'underline',
              color: 'inherit',
              selectors: {
                ':hover': {
                  color: 'inherit'
                },
                ':focus': {
                  color: 'inherit'
                },
                ':active': {
                  color: 'inherit'
                },
                ':active:hover': {
                  color: 'inherit'
                }
              }
            }
          }
        },
        messageBarType === MessageBarType.info && {
          color: INFO_COLOR,
          background: INFO_BACKGROUND_COLOR,
          borderBottom: `1px solid ${INFO_BOTTOM_BORDER_COLOR}`
        },
        messageBarType === MessageBarType.error && {
          color: ERROR_COLOR,
          background: ERROR_BACKGROUND_COLOR,
          borderBottom: `1px solid ${ERROR_BOTTOM_BORDER_COLOR}`
        }
      ]
    } as Partial<IMessageBarStyles>;

    return styles;
  };
}
